const r = (t, e = "text") => e === "text" ? `var(--font-size-${t})` : `var(--font-size-display-${t})`, a = (t, e = "text") => e === "text" ? `var(--line-height-${t})` : `var(--line-height-display-${t})`, i = (t) => `var(--font-weight-${t})`;
export {
  r as createFontSizeVariables,
  i as createFontWeightVariables,
  a as createLineHeightVariables
};
//# sourceMappingURL=highrise.es447.js.map
